import React, { useState } from 'react';
import styled from 'styled-components';
import SaleDetailsPopup from './SaleDetailsPopup';
import BannerText from './BannerText';

const Wrapper = styled.div`
  background: ${props => props.$bgColor || (props.theme.old ? props.theme.colors.french : props.theme.colors.newPromo) };
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px;

  .copy {
    color: ${props => props.$textColor || '#ffffff'};
  }

  .sale-page-linkm, .see-details-btn {
    color: ${props => props.$textColor || '#ffffff'};
    text-decoration: underline;

    &:hover {
      color: ${props => props.$textColor || '#ffffff'};
    }
  }
`;

function NavBannerDesktop({ className }) {
  const [open, setOpen] = useState(false);
  const [colors, setColors] = useState({ bgColor: null, textColor: null });

  const toggle = () => {
    setOpen(!open);
  };
  return (
    <Wrapper className={className ? className : ''} $bgColor={colors.bgColor} $textColor={colors.textColor}>
      <BannerText onClick={toggle} onColors={setColors} />
      <SaleDetailsPopup open={open} toggle={toggle} />
    </Wrapper>
  );
}

export default NavBannerDesktop;
